<template>
  <Dialog
    is-persistent
    title="Select project template"
    :dialog="isOpened"
    confirmation-button-text="Continue"
    :is-confirmation-button-disabled="!selectedProjectId"
    @confirmationAction="confirmSelection"
  >
    <template #content>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row class="pb-4">
          <v-col>
            <v-autocomplete
              id="template-project-select"
              v-model="selectedProjectId"
              :items="sortedProjects"
              item-text="title"
              item-value="id"
              class="secondary-background"
              label="Project"
              hide-details
              outlined
              dense
              clearable
              :rules="[(value) => !!value || 'Project is required']"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </Dialog>
</template>

<script>
import { mapGetters } from 'vuex';

import { Dialog } from '@/components/shared';
import { CollectionsHelper } from '@/helpers/collections.helper';

export default {
  components: {
    Dialog,
  },
  props: {
    isOpened: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      valid: true,
      selectedProjectId: null,
    };
  },
  computed: {
    ...mapGetters('projects/filters', ['allProjectsForOptions']),

    sortedProjects() {
      return CollectionsHelper.sortObjectsByProperty(
        this.allProjectsForOptions,
        'title'
      );
    },
  },
  watch: {
    isOpened(value) {
      if (value) {
        this.reset();
      }
    },
  },
  created() {
    document.addEventListener('keydown', this.handleKeypress);
  },
  destroyed() {
    document.removeEventListener('keydown', this.handleKeypress);
  },
  methods: {
    confirmSelection(confirmed) {
      if (!confirmed) {
        this.closeDialog();

        return;
      }

      if (!this.$refs.form.validate()) {
        return;
      }

      const selectedProject = this.sortedProjects.find(
        (project) => project.id === this.selectedProjectId
      );

      this.$emit('select', selectedProject);
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('close');
      this.reset();
    },
    reset() {
      this.selectedProjectId = null;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    handleKeypress(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeDialog();
      }
    },
  },
};
</script>
